import { PaxCheckTravelDocument } from "../../api";
import { LocalDate } from "../../utils";
import Gender, { GenderToApi } from "./gender";
import { PassportTypeFromCode, PassportTypeToApi } from "./passport-type";

export enum PassportFieldName {
  birthdate = "birthdate",
  countryCode = "countryCode",
  nationality = "nationality",
  expiryDate = "expiryDate",
  givenName = "givenName",
  number = "number",
  gender = "gender",
  surname = "surname",
  passportType = "passportType",
}

interface InternationalPassport {
  [PassportFieldName.birthdate]: LocalDate;
  [PassportFieldName.countryCode]: string;
  [PassportFieldName.nationality]: string;
  [PassportFieldName.expiryDate]: LocalDate;
  [PassportFieldName.givenName]: string;
  [PassportFieldName.number]: string;
  [PassportFieldName.gender]: Gender;
  [PassportFieldName.surname]: string;
  [PassportFieldName.passportType]: string;
}

export function InternationalPassportToApiTravelDocument(
  p: InternationalPassport
): PaxCheckTravelDocument {
  return {
    documentType: "PASSPORT",
    birthdate: p.birthdate.toUtcDate(),
    countryCode: p.countryCode,
    nationality: p.nationality,
    expiryDate: p.expiryDate.toUtcDate(),
    givenName: p.givenName,
    number: p.number,
    sex: GenderToApi(p.gender),
    surname: p.surname,
    subType: PassportTypeToApi(PassportTypeFromCode(p.passportType)),
  };
}

export default InternationalPassport;
